(() => {
  let bannerLoad;
  function loadBanner() {
    if (window.privacyBanner?.showPreferences) return Promise.resolve(window.privacyBanner);
    if (!bannerLoad) {
      bannerLoad = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const timeout = window.setTimeout(() => reject(new Error('Cookievoorkeuren niet beschikbaar')), 10000);
        script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
        script.async = true;
        script.onload = () => {
          window.clearTimeout(timeout);
          if (window.privacyBanner?.showPreferences) resolve(window.privacyBanner);
          else reject(new Error('Cookievoorkeuren niet beschikbaar'));
        };
        script.onerror = () => { window.clearTimeout(timeout); reject(new Error('Cookievoorkeuren niet beschikbaar')); };
        document.head.appendChild(script);
      }).catch(error => { bannerLoad = undefined; throw error; });
    }
    return bannerLoad;
  }
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[href]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.hash !== '#cookie-instellingen') return;
    event.preventDefault();
    link.setAttribute('aria-busy', 'true');
    const previousMessage = link.parentElement.querySelector('[data-cookie-error]');
    if (previousMessage) previousMessage.remove();
    try {
      const banner = await loadBanner();
      await banner.showPreferences();
    } catch (_) {
      const message = document.createElement('p');
      message.dataset.cookieError = '';
      message.setAttribute('role', 'status');
      message.textContent = JSON.parse(document.getElementById('sesseq-privacy-strings').textContent);
      link.insertAdjacentElement('afterend', message);
    } finally {
      link.removeAttribute('aria-busy');
    }
  });
})();
